import axios from 'axios'
import router from '../router'
import Vue from 'vue'
axios.interceptors.response.use(success => {

    if (success.status && success.status == 200) {
        if (success.data.message && success.data.message !== '') {
            Vue.$toast.clear();
        }
        // エラーメッセージ
        if (success.data.status == 500) {
            Vue.$toast.open({
                message: success.data.message,
                type: 'error'
            });
            return success.data;
        }
        // 警告メッセージ
        if (success.data.status == 999) {
            Vue.$toast.open({
                message: success.data.message,
                type: 'warning'
            });
            return success.data;
        }
        // 情報メッセージ
        if (success.data.status == 100) {
            Vue.$toast.open({
                message: success.data.message,
                type: 'info'
            });
            return success.data;
        }
    }
    if (success.data.message) {
        if (success.data.message && success.data.message !== '') {
            Vue.$toast.clear();
        }
        Vue.$toast.open({
            message: success.data.message,
            type: 'success'
        });
    }
    return success.data;
}, error => {
    Vue.$toast.clear();
    if (error.response.status == 404) {
        Vue.$toast.open({
            message: '要求されたリソースが見つかりませんでした。',
            type: 'error'
        });
    } else if (error.response.status == 504) {
        Vue.$toast.open({
            message: '一定期間の間ゲートウェイから応答がなかった。',
            type: 'error'
        });
    } else if (error.response.status == 403) {
        Vue.$toast.open({
            message: '権限が不十分な場合は、管理者に連絡してください。',
            type: 'error'
        });
    } else if (error.response.status == 401) {
        Vue.$toast.open({
            message: 'ログインしていません、ログインしてください。',
            type: 'error'
        });
        
        //console.log("aaa")
        //store.commit('resetState')
        router.replace('/logout');     
        //this.$router.go(this.$router.currentRoute.path)
    } else {
        if (error.data.message) {
            Vue.$toast.open({
                message: error.data.message,
                type: 'error'
            });
        } else {
            Vue.$toast.open({
                message: 'システムエラー!',
                type: 'error'
            });
        }
    }
    return;
})

let base = '';

export const postKeyValueRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let i in data) {
                ret += encodeURIComponent(i) + '=' + encodeURIComponent(data[i]) + '&'
            }
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}
export const postRequest = (url, params, token) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        headers: { 'Authorization': 'Bearer ' + token }
    })
}
export const postUploadRequest = (url, params, token) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        // header: { 'Content-Type': 'multipart/form-data' },
        config: 'multipart/form-data',
        data: params,
        headers: { 'Authorization': 'Bearer ' + token }
    })
}
export const putRequest = (url, params, token) => {
    return axios({
        method: 'put',
        url: `${base}${url}`,
        data: params,
        headers: { 'Authorization': 'Bearer ' + token }
    })
}
export const getRequest = (url, params,token) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params: params,
        headers: { 'Authorization': 'Bearer ' + token }
    })
}
export const deleteRequest = (url, params,token) => {
    return axios({
        method: 'delete',
        url: `${base}${url}`,
        data: params,
        headers: { 'Authorization': 'Bearer ' + token }
    })
}

export function getFileAccessHttpUrl(avatar, subStr) {
    if (!subStr) subStr = 'http'
    if (avatar && avatar.startsWith(subStr)) {
        return avatar;
    } else {
        if (subStr !== 'http') {
            return subStr + "/" + avatar;
        }
        if (avatar && avatar.length > 0 && avatar.indexOf('[') == -1) {
            return window._CONFIG['staticDomainURL'] + "/" + avatar;
        }
    }
}

export const getStreamRequest = (url, params, token) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        responseType: 'arraybuffer',
        headers: { 'Authorization': 'Bearer ' + token }
    })
}